import * as React from 'react';
import { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import { Alert, Button, Col, FormGroup, Input, Label } from 'reactstrap';
import * as sjcl from 'sjcl';

const displaySecret = (props: any & React.HTMLAttributes<HTMLElement>) => {
  const [loading, setLoading] = useState(false);
  const [error, showError] = useState(false);
  const [secret, setSecret] = useState('');

  const decrypt = async () => {
    setLoading(true);
    const url = process.env.REACT_APP_BACKEND_URL
      ? `${process.env.REACT_APP_BACKEND_URL}/secret`
      : '/secret';
    try {
      const request = await fetch(`${url}/${props.match.params.key}`);
      if (request.status === 200) {
        const data = await request.json();
        setSecret(sjcl.decrypt(props.match.params.password, data.message));
        setLoading(false);
        return;
      }
    } catch (e) {
      console.log(e);
    }
    setLoading(false);
    showError(true);
  };

  useEffect(
    () => {
      if (props.match.params.password) {
        decrypt();
      }
    },
    [props.match.params.password],
  );

  return (
    <div>
      {loading && (
        <h3>
          Fetching from database and decrypting in browser, please hold...
        </h3>
      )}
      <Error display={error} />
      <Secret secret={secret} />
      <Form
        display={!props.match.params.password}
        uuid={props.match.params.key}
      />
    </div>
  );
};

const Form = (
  props: {
    readonly display: boolean;
    readonly uuid: string;
  } & React.HTMLAttributes<HTMLElement>,
) => {
  const [password, setPassword] = useState('');
  const [redirect, setRedirect] = useState(false);

  if (redirect) {
    return <Redirect to={`/s/${props.uuid}/${password}`} />;
  }
  return props.display ? (
    <Col sm="6">
      <FormGroup>
        <Label>A decryption key is required, please enter it below</Label>
        <Input
          type="text"
          autoFocus={true}
          placeholder="Decryption Key"
          value={password}
          onChange={e => setPassword(e.target.value)}
        />
      </FormGroup>
      <Button block={true} size="lg" onClick={() => setRedirect(true)}>
        Decrypt Secret
      </Button>
    </Col>
  ) : null;
};

const Error = (
  props: { readonly display: boolean } & React.HTMLAttributes<HTMLElement>,
) =>
  props.display ? (
    <div>
      <Alert color="danger">
        <h4 className="alert-heading">Secret does not exist</h4>
        <p>
          It might be caused by one of the following reasons.
        </p>
        
        <p className="mb-0">
        <h5>Opened before</h5>Secret Share allows secrets to be displayed <b>once</b>.
        <p>
          In this case it is possible that the secret is compromised and read by someone else. You
          should contact the sender and request a new secret.
        </p>
        <h5>Broken link</h5>
        <p>
          The link you have received must match perfectly in order for the local decryption
          to work.
        </p>
        <h5>Expired</h5>
        <p>
          No secrets last forever. All stored encrypted secrets will expire and self destruct.
        </p>
        </p>
      </Alert>
    </div>
  ) : null;

const Secret = (
  props: { readonly secret: string } & React.HTMLAttributes<HTMLElement>,
) =>
  props.secret ? (
    <div>
      <h1>Decrypted Secret</h1>
      <Alert color="success">
        Secret succesfully pulled from the server and decrypted locally.
      </Alert>
      <Alert color="warning">
        This secret will not be viewable again, make sure to save it now!
      </Alert>

      <pre>{props.secret}</pre>
    </div>
  ) : null;

export default displaySecret;



// WEBPACK FOOTER //
// ./src/DisplaySecret.tsx